import { render, staticRenderFns } from "./CasoCompletoFavCustomCols.vue?vue&type=template&id=47a86a8c&"
import script from "./CasoCompletoFavCustomCols.vue?vue&type=script&lang=js&"
export * from "./CasoCompletoFavCustomCols.vue?vue&type=script&lang=js&"
import style0 from "./CasoCompletoFavCustomCols.vue?vue&type=style&index=0&id=47a86a8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports